import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { resetAll } from "./actions/resetAll"
import { de } from "date-fns/locale"

const initialState = {
    n: 0
}

export const modeloSlice = createSlice({
    name: "modelo",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers : {
        reset : () => initialState,
        incrementar: (modelo, action: PayloadAction<number>) => {
            modelo.n += action.payload
        },
        decrementar: (modelo, action: PayloadAction<number>) => {
            modelo.n -= action.payload
        }
    }
})

export const {
    incrementar: incrementarAction,
    decrementar: decrementarAction
} : {
    incrementar: ActionType<number>,
    decrementar: ActionType<number>
} = modeloSlice.actions

export default modeloSlice.reducer